var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeguro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.611,
    height: 50.689,
    viewBox: "0 0 119.611 50.689"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.719,
    x2: 0.5,
    y2: 0.555,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2.559,
    y1: -0.473,
    x2: 0.243,
    y2: 0.575,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.278,
    y1: -0.863,
    x2: 0.517,
    y2: 0.62,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguro_Residencial",
    "data-name": "Seguro Residencial",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M42.452,25.578c-.129-.031-.261-.06-.392-.091.225.045.445.091.66.139a2.1,2.1,0,0,0,2.5-1.548,55.057,55.057,0,0,0,1.407-8.684A2.108,2.108,0,0,0,45.4,13.306c-2.055-.94-4.055-1.966-5.961-3.055V4.325A2.105,2.105,0,0,0,37.332,2.22h-5.89a2.1,2.1,0,0,0-1.885,1.17c-1.077-.9-2.122-1.842-3.124-2.8a2.1,2.1,0,0,0-2.916,0A68.357,68.357,0,0,1,4.551,13.306a2.107,2.107,0,0,0-1.222,2.088,55.056,55.056,0,0,0,1.407,8.684,2.1,2.1,0,0,0,2.5,1.548c.22-.048.445-.1.677-.141l-.411.093C2.236,26.824-.278,28.762.023,31.333.241,33.187,2.03,35.388,9.235,35.5A40.284,40.284,0,0,0,23.9,50.392a2.1,2.1,0,0,0,2.153,0A40.3,40.3,0,0,0,40.715,35.5c7.205-.112,8.995-2.313,9.212-4.167C50.229,28.759,47.712,26.824,42.452,25.578Zm77.113-8.38a6.82,6.82,0,0,0-1.622-5.368,6.971,6.971,0,0,0-5.282-2.208,8.07,8.07,0,0,0-5.76,2.332,4.419,4.419,0,0,0-.4-.517,5.294,5.294,0,0,0-4.017-1.648H97.451a2.1,2.1,0,0,0-1.091.3,2.094,2.094,0,0,0-1.091-.3H92.65a2.105,2.105,0,0,0-2.093,1.885l-.033.321c0-.033,0-.067,0-.1a2.1,2.1,0,0,0-2.1-2.105H85.784a2.1,2.1,0,0,0-1.966,1.354,6.516,6.516,0,0,0-4.354-1.521,8.261,8.261,0,0,0-4.854,1.526,2.1,2.1,0,0,0-1.966-1.359H65.278a2.1,2.1,0,0,0-1.734.911,8.067,8.067,0,0,0-4.153-1.062c-3.863,0-6.155,2.572-6.421,5.112a4.526,4.526,0,0,0,.66,3.093L52.48,19.327a2.106,2.106,0,0,0,.134,2.739,6.914,6.914,0,0,0,1.7,1.311,2.079,2.079,0,0,0-.431,1.072l-.574,5.473A2.1,2.1,0,0,0,55.4,32.247h1.153a2.1,2.1,0,0,0,.954-.227,2.087,2.087,0,0,0,.955.227h1.33a2.1,2.1,0,0,0,.962-.232,2.112,2.112,0,0,0,.962.232h3.83a2.1,2.1,0,0,0,1.364-.5,5.3,5.3,0,0,0,2.555.6,4.862,4.862,0,0,0,2.6-.677,2.1,2.1,0,0,0,1.45.579h1.153a2.117,2.117,0,0,0,1.084-.3,2.11,2.11,0,0,0,1.084.3h2.143a5.444,5.444,0,0,0,3.057-.9,2.11,2.11,0,0,0,1.725.9h3.83a2.108,2.108,0,0,0,1-.251,2.114,2.114,0,0,0,1,.251h1.153a2.1,2.1,0,0,0,1.289-.443,2.1,2.1,0,0,0,1.289.443h1.112a2.1,2.1,0,0,0,1.742-.921,5,5,0,0,0,5.607.3,2.11,2.11,0,0,0,1.49.62h1.153a2.07,2.07,0,0,0,.8-.158,2.1,2.1,0,0,0,.8.158h1.306a2.113,2.113,0,0,0,1.5-.629,2.1,2.1,0,0,0,1.5.629h1.306a2.078,2.078,0,0,0,.775-.148,2.126,2.126,0,0,0,.775.148h3.45a2.105,2.105,0,0,0,2.093-1.885l.108-1.026a2.1,2.1,0,0,0-2.045-2.325L117,24.975a2.138,2.138,0,0,0,.022-.3,2.1,2.1,0,0,0-.871-1.706A7.879,7.879,0,0,0,119.565,17.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488",
    transform: "translate(1.901 2.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    transform: "translate(53.292 22.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M233.78,108.963l-.859-1.945h-.844l-.2,1.945H230.72l.574-5.473h2.531a1.509,1.509,0,0,1,1.641,1.763,1.8,1.8,0,0,1-1.364,1.624l1.007,2.084h-1.33Zm.5-3.718a.65.65,0,0,0-.727-.73h-1.218l-.155,1.476H233.4A.831.831,0,0,0,234.282,105.246Z",
    transform: "translate(-230.72 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M257.12,108.963l.574-5.473h3.83l-.108,1.026h-2.679l-.12,1.148h2.622l-.108,1.026H258.51l-.132,1.246h2.679l-.108,1.026Z",
    transform: "translate(-250.805 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M280.25,107.934l.73-.911a2.115,2.115,0,0,0,1.641.746c.641,0,.971-.287,1-.608.1-.952-3.086-.287-2.871-2.347a2.05,2.05,0,0,1,2.227-1.665,2.715,2.715,0,0,1,2.031.763l-.732.871a2.082,2.082,0,0,0-1.512-.6c-.488,0-.785.213-.82.541-.091.861,3.079.28,2.866,2.323-.105,1-.9,1.756-2.352,1.756A2.818,2.818,0,0,1,280.25,107.934Z",
    transform: "translate(-268.401 -103.143)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M306.42,108.963l.574-5.473h1.153l-.574,5.473Z",
    transform: "translate(-288.311 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M320.29,108.963l.574-5.473H323a2.364,2.364,0,0,1,2.586,2.732,3.012,3.012,0,0,1-3.151,2.741Zm4.117-2.739a1.413,1.413,0,0,0-1.51-1.706h-.99l-.359,3.421h.981A1.852,1.852,0,0,0,324.407,106.224Z",
    transform: "translate(-298.863 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M349.23,108.963l.574-5.473h3.83l-.108,1.026H350.85l-.12,1.148h2.622l-.108,1.026h-2.622l-.132,1.246h2.677l-.108,1.026Z",
    transform: "translate(-320.88 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M377.324,108.963l-2.208-3.569-.373,3.569H373.59l.574-5.473h1.184l2.148,3.438.361-3.438h1.153l-.574,5.473Z",
    transform: "translate(-339.412 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M402.962,105.95a3.132,3.132,0,0,1,3.186-2.83,2.164,2.164,0,0,1,2.115,1.337l-1.041.493a1.288,1.288,0,0,0-1.182-.8,1.926,1.926,0,0,0-1.892,1.8,1.506,1.506,0,0,0,1.517,1.8,1.662,1.662,0,0,0,1.349-.8l.94.483a2.805,2.805,0,0,1-2.4,1.344A2.449,2.449,0,0,1,402.962,105.95Z",
    transform: "translate(-361.744 -103.12)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M430.8,108.963l.574-5.473h1.153l-.574,5.473Z",
    transform: "translate(-382.936 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M446.608,108.963l-.244-.928h-2.32l-.438.928H442.3l2.66-5.473h1.445l1.512,5.473Zm-1.05-4.306-1.091,2.354h1.689Z",
    transform: "translate(-391.685 -103.401)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    "data-name": "Caminho 724",
    d: "M472.26,108.963l.574-5.473h1.16l-.466,4.447h2.289l-.108,1.026Z",
    transform: "translate(-414.478 -103.401)",
    fill: "#123d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484",
    transform: "translate(52.034 9.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M225.46,58.335l1.584-2.041a4.058,4.058,0,0,0,3.081,1.34c.873,0,1.447-.3,1.5-.806.141-1.34-5.653-.23-5.244-4.141.179-1.706,1.753-3.227,4.328-3.227a5.532,5.532,0,0,1,3.933,1.416l-1.622,1.964a4.194,4.194,0,0,0-2.825-1.065c-.754,0-1.11.258-1.158.7-.132,1.249,5.646.3,5.249,4.079-.213,2.041-1.847,3.395-4.54,3.395A5.584,5.584,0,0,1,225.46,58.335Z",
    transform: "translate(-225.46 -49.446)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M267.57,60.253,268.635,50.1H276l-.239,2.285h-4.773l-.165,1.584h4.667l-.239,2.282h-4.667l-.184,1.72h4.773l-.239,2.282Z",
    transform: "translate(-257.496 -49.933)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M306.182,54.651a5.84,5.84,0,0,1,5.985-5.251,4.128,4.128,0,0,1,4.033,2.466l-2.287,1.141a2.188,2.188,0,0,0-1.988-1.294,3.157,3.157,0,0,0-3.108,2.938,2.473,2.473,0,0,0,2.493,2.938,3.457,3.457,0,0,0,1.916-.61l.084-.792h-2.258l.242-2.3h4.849l-.423,4.033a6.412,6.412,0,0,1-4.648,1.978C308.072,59.9,305.845,57.878,306.182,54.651Z",
    transform: "translate(-286.846 -49.4)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M354.99,56.143l.634-6.043h2.634l-.624,5.952a1.724,1.724,0,0,0,1.907,2.069,2.186,2.186,0,0,0,2.325-2.069l.624-5.952h2.62l-.632,6.028c-.266,2.526-1.957,4.308-5.179,4.308S354.729,58.64,354.99,56.143Z",
    transform: "translate(-323.979 -49.933)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M407.663,60.253l-1.33-3.409h-1.325l-.356,3.409H402.06L403.125,50.1h5.028a2.888,2.888,0,0,1,3.139,3.38,3.489,3.489,0,0,1-2.32,3.045l1.658,3.729h-2.966Zm1-6.789c.074-.7-.445-1.081-1.136-1.081h-2.048l-.227,2.177H407.3A1.257,1.257,0,0,0,408.66,53.463Z",
    transform: "translate(-359.813 -49.933)",
    fill: "#123d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M445.215,54.651a5.827,5.827,0,0,1,5.926-5.251,4.544,4.544,0,0,1,4.811,5.251A5.814,5.814,0,0,1,450.04,59.9,4.554,4.554,0,0,1,445.215,54.651Zm8.1,0a2.417,2.417,0,0,0-2.419-2.938,3.1,3.1,0,0,0-3.048,2.938,2.435,2.435,0,0,0,2.433,2.938A3.1,3.1,0,0,0,453.318,54.651Z",
    transform: "translate(-392.619 -49.4)",
    fill: "#123d64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_485",
    "data-name": "Grupo 485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M49.5,59.81,38.211,72.293a45.46,45.46,0,0,0-5.7.926,41.838,41.838,0,0,0,2.5,5.77A38.213,38.213,0,0,0,49.5,94.179,38.2,38.2,0,0,0,63.994,78.989a42,42,0,0,0,2.5-5.77,45.533,45.533,0,0,0-5.7-.926ZM49.05,76.972H45.438V73.36H49.05Zm0-4.6H45.438V68.762H49.05Zm4.517,4.6H49.954V73.36h3.612Zm0-4.6H49.954V68.762h3.612Z",
    transform: "translate(-26.634 -47.696)",
    fill: "#123d64",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M38.32,72.919a37.122,37.122,0,0,0,15.6,19.607V59.81L42.631,72.293C41.021,72.46,39.585,72.673,38.32,72.919Zm11.538-4.16H53.47v3.612H49.858Zm0,4.6H53.47v3.612H49.858Z",
    transform: "translate(-31.055 -47.696)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M14.076,113.607a55.515,55.515,0,0,1,6.067-1.067l-.617-.56a45.457,45.457,0,0,0-5.7.926c-8.918,2.112-7.366,5.949,2.5,5.77-.089-.167-.175-.337-.261-.5C7.971,118.382,5.81,115.621,14.076,113.607Z",
    transform: "translate(-7.949 -87.385)",
    fill: "#24c2ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M56.957,72.85l10.674-11.8V59.81L56.34,72.29Z",
    transform: "translate(-44.764 -47.696)",
    fill: "#24c2ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M15.573,125.8c-4.485,2.134,3.863,2.349,5.012,2.325-.294-.6-.577-1.213-.842-1.832A16.577,16.577,0,0,1,15.573,125.8Z",
    transform: "translate(-12.75 -97.899)",
    fill: "#123d64",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M50.3,65,39.627,76.8a55.411,55.411,0,0,0-6.067,1.067,41.907,41.907,0,0,0,1.986,4.562c-.053-2.5,1.3-4.265,4.643-5.009L50.3,66.242,60.41,77.418c3.342.744,4.7,2.514,4.643,5.009a41.646,41.646,0,0,0,1.986-4.562A55.412,55.412,0,0,0,60.973,76.8Z",
    transform: "translate(-27.433 -51.644)",
    fillRule: "evenodd",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    "data-name": "Caminho 737",
    d: "M154.478,112.906a45.533,45.533,0,0,0-5.7-.926l-.617.56a55.416,55.416,0,0,1,6.067,1.067c8.265,2.014,6.1,4.775-1.986,4.562-.086.17-.172.337-.261.5C161.844,118.855,163.4,115.021,154.478,112.906Z",
    transform: "translate(-114.618 -87.385)",
    fill: "#24c2ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    "data-name": "Caminho 738",
    d: "M171.392,125.8a16.672,16.672,0,0,1-4.17.5c-.266.62-.548,1.23-.842,1.832C167.528,128.149,175.877,127.934,171.392,125.8Z",
    transform: "translate(-128.48 -97.899)",
    fill: "#123d64",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M53.735,18.526a76.273,76.273,0,0,0,7.191,3.758,52.5,52.5,0,0,1-1.352,8.349,47.461,47.461,0,0,0-5.2-.811l-1.77-1.957V12.514H47.845V11.388h5.89ZM21.83,22.284a52.5,52.5,0,0,0,1.352,8.349,47.554,47.554,0,0,1,5.2-.811l13-14.37L47.843,22.6v-7.98A66.062,66.062,0,0,1,41.377,9.17,70.055,70.055,0,0,1,21.83,22.284Z",
    transform: "translate(-18.509 -9.17)",
    fill: "#24c2ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    "data-name": "Caminho 740",
    d: "M150.48,60.7l1.77,1.957c1.4.146,2.672.328,3.813.533a50.689,50.689,0,0,0,1.242-7.215,77.334,77.334,0,0,1-6.825-3.651Z",
    transform: "translate(-116.383 -41.998)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_741",
    "data-name": "Caminho 741",
    d: "M28.07,29.3a50.752,50.752,0,0,0,1.242,7.215c1.139-.206,2.409-.388,3.813-.533l13-14.37,6.466,7.148V22.516a67.722,67.722,0,0,1-6.466-5.256A71.73,71.73,0,0,1,28.07,29.3Z",
    transform: "translate(-23.257 -15.325)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487",
    transform: "translate(91.505 31.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_742",
    "data-name": "Caminho 742",
    d: "M409.332,140.02a4.431,4.431,0,0,0-3.914,2.328,2.219,2.219,0,0,0-.385-.033,2.637,2.637,0,0,0-.945.163,1.711,1.711,0,0,0-.211-.411,1.655,1.655,0,0,0-1.526-.677h-1.1a.632.632,0,0,0-.323.086.67.67,0,0,0-.335-.086h-.45a.628.628,0,0,0-.643.627v.3h-.012a1.7,1.7,0,0,0-1.316.574.867.867,0,0,0-.086-.1,1.65,1.65,0,0,0-1.254-.476,1.778,1.778,0,0,0-1,.268,1.34,1.34,0,0,0-.835-.268,1.523,1.523,0,0,0-.5.084.653.653,0,0,0-.256-.053h-.33a.649.649,0,0,0-.249-.562,2.241,2.241,0,0,0-1.344-.466,1.789,1.789,0,0,0-1.859,1.876v1.16a1.824,1.824,0,0,0,.617,1.459,1.93,1.93,0,0,0,1.251.435,2.2,2.2,0,0,0,1.038-.242.644.644,0,0,0,.44.175h.454a.645.645,0,0,0,.644-.644v-.4h.285a1.556,1.556,0,0,0,.313.6,1.652,1.652,0,0,0,1.316.507,4.872,4.872,0,0,0,1.148-.153.61.61,0,0,0,.366-.254,1.825,1.825,0,0,0,1.215.407,3.885,3.885,0,0,0,1.263-.227.6.6,0,0,0,.4.16h.545a.6.6,0,0,0,.6-.6v-.44a2.011,2.011,0,0,0,.959-.237c.041.818.7,1.344,1.7,1.344.077,0,.153,0,.232-.007a4.454,4.454,0,1,0,4.084-6.222Z",
    transform: "translate(-390.46 -140.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486",
    transform: "translate(0.562 0.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_743",
    "data-name": "Caminho 743",
    d: "M457.913,142.37a3.893,3.893,0,0,0-3.476,2.143,1.3,1.3,0,0,1,.639,1.2v1.521a.425.425,0,0,1-.266.4l-.017.007-.017,0a3.558,3.558,0,0,1-.457.105,3.89,3.89,0,1,0,3.593-5.383Z",
    transform: "translate(-439.605 -142.37)",
    fill: "#1ac3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_744",
    "data-name": "Caminho 744",
    d: "M395.169,151.1l-.215-.344a.081.081,0,0,0-.055-.05.076.076,0,0,0-.067.022,1.138,1.138,0,0,1-.72.242.639.639,0,0,1-.689-.713v-1.141a.64.64,0,0,1,.684-.708,1.116,1.116,0,0,1,.675.225.088.088,0,0,0,.077.017.08.08,0,0,0,.048-.045l.218-.347a.093.093,0,0,0-.019-.129,1.653,1.653,0,0,0-1-.344,1.223,1.223,0,0,0-1.3,1.311v1.16a1.233,1.233,0,0,0,1.306,1.33,1.535,1.535,0,0,0,1.041-.359C395.183,151.206,395.207,151.163,395.169,151.1Z",
    transform: "translate(-392.81 -146.486)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M424.6,151.279a1.661,1.661,0,0,0,.438-.055.087.087,0,0,0,.065-.084v-1.359a.125.125,0,0,0-.065-.108.973.973,0,0,0-.447-.1.525.525,0,0,0-.6.584v.493c0,.462.227.629.612.629m.5-3.124c0-.045.036-.065.079-.065h.45c.043,0,.079.01.079.072v3.411a.044.044,0,0,1-.012.029.107.107,0,0,1-.048.029,3.3,3.3,0,0,1-1.069.194,1.085,1.085,0,0,1-1.208-1.179v-.488a1.082,1.082,0,0,1,1.148-1.136,1.482,1.482,0,0,1,.577.117v-.983Z",
    transform: "translate(-416.059 -146.722)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_746",
    "data-name": "Caminho 746",
    d: "M436.46,148.1h-1.1a.061.061,0,0,0-.067.067v3.572a.028.028,0,0,0,.029.029h.545a.037.037,0,0,0,.036-.036v-.947a.054.054,0,0,1,.055-.055h.474a1.293,1.293,0,0,0,.952-.342,1.308,1.308,0,0,0,.376-.99,1.486,1.486,0,0,0-.232-.854C437.323,148.246,437.063,148.1,436.46,148.1Zm.036,2.036h-.538a.054.054,0,0,1-.055-.055v-1.335a.054.054,0,0,1,.055-.055h.567a.547.547,0,0,1,.435.158.64.64,0,0,1,.16.459.906.906,0,0,1-.155.579A.616.616,0,0,1,436.5,150.136Z",
    transform: "translate(-425.128 -146.729)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_747",
    "data-name": "Caminho 747",
    d: "M405.632,152.637a.074.074,0,0,1-.1,0,.589.589,0,0,0-.364-.115.447.447,0,0,0-.433.5v1.608a.08.08,0,0,1-.079.079H404.2a.08.08,0,0,1-.079-.079V152.08A.08.08,0,0,1,404.2,152h.438a.08.08,0,0,1,.079.079v.179a.91.91,0,0,1,.677-.289.791.791,0,0,1,.553.2.087.087,0,0,1,.007.129Z",
    transform: "translate(-401.414 -149.673)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M448.823,154.549v-1.521a.98.98,0,0,0-1.115-1.048,1.85,1.85,0,0,0-1.038.275c-.017.014-.024.033,0,.074l.213.352a.07.07,0,0,0,.041.031.079.079,0,0,0,.05-.012,1.4,1.4,0,0,1,.689-.167c.39,0,.543.151.543.536v.077l-.012,0a4.076,4.076,0,0,0-.531-.041c-.737,0-1.115.3-1.115.825,0,.777.782.861,1.136.861a4.021,4.021,0,0,0,1.084-.155A.094.094,0,0,0,448.823,154.549Zm-.612-.4a.044.044,0,0,1-.031.041,2.386,2.386,0,0,1-.49.057c-.366,0-.533-.1-.533-.323s.148-.354.526-.354a3.921,3.921,0,0,1,.493.038.039.039,0,0,1,.033.038v.5Z",
    transform: "translate(-433.694 -149.681)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    "data-name": "Caminho 749",
    d: "M414.481,153.185a1.288,1.288,0,0,0-.287-.914,1.119,1.119,0,0,0-.844-.3,1.077,1.077,0,0,0-.892.361,1.8,1.8,0,0,0-.287,1.115,1.534,1.534,0,0,0,.273,1.017,1.123,1.123,0,0,0,.89.313,4.368,4.368,0,0,0,1.014-.136.056.056,0,0,0,.043-.057l-.007-.361a.04.04,0,0,0-.014-.033.045.045,0,0,0-.033-.012c-.141.012-.33.026-.438.031-.072,0-.141.01-.206.014-.086.007-.17.012-.237.012a1.256,1.256,0,0,1-.356-.041.329.329,0,0,1-.194-.151.574.574,0,0,1-.045-.261c0-.086.01-.11.05-.11h1.462a.1.1,0,0,0,.1-.1Zm-.682-.045a.059.059,0,0,1-.041.019H412.9a.068.068,0,0,1-.041-.017.054.054,0,0,1-.017-.043.749.749,0,0,1,.117-.433.463.463,0,0,1,.38-.141.442.442,0,0,1,.368.136.753.753,0,0,1,.1.435A.064.064,0,0,1,413.8,153.14Z",
    transform: "translate(-407.539 -149.673)",
    fill: "#103e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_750",
    "data-name": "Caminho 750",
    d: "M464.689,153.159a1.1,1.1,0,0,0-.373-.866,1.109,1.109,0,0,0-.134-.093.657.657,0,0,0-.1-.05.845.845,0,0,0-.108-.043,1.556,1.556,0,0,0-.5-.077H460.84a1.1,1.1,0,0,0-1.23,1.172v.483a1.052,1.052,0,0,0,1.155,1.105,1.6,1.6,0,0,0,.593-.117c.017.538-.218.742-.617.742a1.117,1.117,0,0,1-.7-.222.065.065,0,0,0-.105.022l-.213.328c-.026.048-.026.081.014.108a1.6,1.6,0,0,0,1.043.33c.761,0,1.16-.471,1.16-1.261v-2.108h1.6a.54.54,0,0,1,.541.541v.663a.557.557,0,0,1-.316.514.587.587,0,0,1-.821-.517s0-.6,0-.792c0-.031-.053-.043-.081-.031-.148.074-.414.215-.5.258a.044.044,0,0,0-.026.041v.56a1.08,1.08,0,0,0,.885,1.043,2.214,2.214,0,0,0,.318.029,1.132,1.132,0,0,0,1.141-.971c0-.033,0-.067,0-.1C464.686,153.848,464.689,153.159,464.689,153.159Zm-3.356.957a.932.932,0,0,1-.531.129c-.325,0-.588-.134-.588-.555v-.529c0-.459.251-.586.62-.586a1.916,1.916,0,0,1,.5.06v1.481Z",
    transform: "translate(-443.63 -149.719)",
    fill: "#fff"
  })))))));
}
export default __webpack_public_path__ + "static/seguro.f8e11055.svg";
export { SvgSeguro as ReactComponent };